export default {
  Community: {
    title: "انجمن",
    description: "تبادل دانش میان پزشکان دربارهٔ موارد بالینی",
    all_cases: "همهٔ کیس‌ها",
    my_cases: "کیس‌های من",
    case: {
      shareLink: {
        1: "این کیس را ببینید",
        2: "در پلتفرم “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
  },
  h1_community: "جامعه پزشکان",
};
